import { isNumber } from '../../../utils/base'

import router from '../../../routers/index'
import { WZ } from '../../../common/globals'

function back({ state, dispatch }, n) {
  n = n && isNumber(n) ? n : -1
  const { backUrl } = state
  const { length } = history

  dispatch('setBackUrl', '')

  if (n === -1) {
    if (backUrl) {
      if (/\/\w+/.test(backUrl)) {
        return router.replace(location)
      } else {
        return location.replace(backUrl)
      }
    } else if (length === 0) {
      // 无上一页
      return router.replace('/')
    }
  }
  return router.go(n)
}

export default {
  // 后退
  back,

  // 路由切换
  change({ state, getters }, { matched, meta, fullPath }) {
    // mutation
    state.fullPath = fullPath
    state.mata = meta
    state.matched = matched

    const { pageType, tabIndex } = getters

    // const {tabs, pageType} = getters
    // const tabCount = tabs.length
    // let tabIndex = -2  // -2 不显示底导航  -1: 显示底导航（无高亮） >= 0 显示底导航（高亮对应项）
    // // console.log(tabs)
    // if (meta && isNumber(meta.tabIndex)) {
    //   tabIndex = meta.tabIndex
    // } else if (matched) {
    //   // console.log(matched)
    //   for (let index = matched.length - 1; index >= 0; index--) {
    //     const route = matched[index]
    //     const {regex} = route
    //     const i = findIndex(tabs, ({path}) => regex.test(path))
    //     // console.log(route.path)
    //     if (i >= 0) {
    //       tabIndex = i
    //       break
    //     }
    //   }
    // }
    // console.log({
    //   pageType,
    //   tabIndex,
    //   fullPath
    // })
    // tabIndex = tabIndex >= tabCount ? -1 : tabIndex

    // commit('update', {
    //   tabIndex
    // })

    WZ.appPush('webPageInfo.changed', {
      tabIndex,
      pageType
    })
  },

  // 设置后退URL
  setBackUrl({ commit }, backUrl) {
    // console.log(backUrl)
    commit('update', {
      backUrl
    })
  }
}
